// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__Oabm+","animationRow":"Loading_animationRow__DVIcP","dualRing":"Loading_dualRing__55tCD"};